export default __webpack_public_path__ + "f152cd907d7729d87782a5652462f07a.png";